import { html } from 'lit';
import { ChevronUp } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-chevron-up')
export class PdsIconChevronUp extends PdsIcon {
  @state()
  icon = ChevronUp;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
